






import { Component, Vue, Prop } from 'vue-property-decorator';
import TextInput from '@/components/TextInput/TextInput.vue';
import FlexButton from '@/components/FlexButton/FlexButton.vue';

@Component({
  components: {
    TextInput,
    FlexButton
  }
})
export default class CopyInput extends Vue {
  @Prop({ default: '' }) value!: string;

  onCopy() {
    this.$emit('copy');
  }
}
